import { ElementViewTemplate, html, slotted } from "@microsoft/fast-element";
import { NatGenOption } from "./option";
import { OptionOptions as OptionOptions } from "./option.options";
import { endSlotTemplate, startSlotTemplate } from "../start-end/start-end";

export function optionTemplate<T extends NatGenOption>(
    options: OptionOptions = {}
): ElementViewTemplate<T> {
    return html<T>`
        <template
            aria-checked="${x => x.ariaChecked}"
            aria-disabled="${x => x.ariaDisabled}"
            aria-posinset="${x => x.ariaPosInSet}"
            aria-selected="${x => x.ariaSelected}"
            aria-setsize="${x => x.ariaSetSize}"
            role="option"
        >
            ${startSlotTemplate(options)}
            <span class="content" part="content">
                <slot ${slotted("content")}></slot>
            </span>
            ${endSlotTemplate(options)}
        </template>
    `;
}
